import { FC } from 'react';
import {
  CreateButton,
  Datagrid,
  EditButton,
  FieldProps,
  List,
  TextField,
  TopToolbar,
  useRecordContext,
} from 'react-admin';

const ListActions = () => (
  <TopToolbar>
    <CreateButton label="Добавить ленту" />
  </TopToolbar>
);

const TypeField = (props: FieldProps) => {
  const value = useRecordContext(props);
  const { type } = value;
  if (String(type) === 'headings') {
    return <span>Рубрика</span>;
  }
  if (String(type) === 'course') {
    return <span>Курс</span>;
  }
  return <span>Неизвестно</span>;
};

export const FeedList: FC = () => (
  <List title="Список лент" filter={{}} actions={<ListActions />}>
    <Datagrid rowClick="show">
      <TypeField source="type" label="Тип" />
      <TextField source="id" label="ID" />
      <TextField source="name" label="Название" />
      <TextField source="description" label="Описание" />
      <EditButton label="Редактировать" />
    </Datagrid>
  </List>
);
